export default __webpack_public_path__ + "static/media/GraceMa.b0297dec.jpg";